import {API_URL, apiPost} from '../api'

export const editLeagueApi = async data => {
    return await apiPost(API_URL, 'admin/league_edit', data)
}
